import qs from 'qs'

export const parseSearch = (search) => {
  return qs.parse(search, {
    ignoreQueryPrefix: true
  })
}